import React from 'react';

export default class NotFound extends React.Component {
    render() {
        return (
            <div className="App">
                <h1>Not found (404 error)</h1>
            </div>
        );
    }
}